"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_EXECUTIONS, (table)=>{
        table.timestamp('resume_at').nullable();
    });
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_EXECUTIONS, (table)=>{
        table.index([
            'fk_workspace_id',
            'base_id',
            'resume_at'
        ], 'nc_automation_executions_resume_idx');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_EXECUTIONS, (table)=>{
        table.dropIndex([], 'nc_automation_executions_resume_idx');
        table.dropColumn('resume_at');
    });
};
